"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSelectedCrewOn = exports.onLeave = exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageUiSubsystem_sidecar_1 = require("@voyage/ui/voyageUiSubsystem-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 2;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        if (voyageSystems_sidecar_1.voyageSystems.testNoPower(obj)) {
            return;
        }
        var possibleReports = [];
        var status_1 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        var report = '';
        if (status_1.hasBoarders.isActive) {
            possibleReports.push.apply(possibleReports, ['Boarders!', 'Aliens!', 'Intruders detected!']);
        }
        if (status_1.hasFire.isActive) {
            possibleReports.push.apply(possibleReports, ['FIRE!', 'Fire on deck', 'Smoke detected']);
        }
        if (status_1.hasBreach.isActive) {
            possibleReports.push.apply(possibleReports, [
                'Hull breach!',
                'We are losing oxygen',
                'Hull damage detected',
                'Hull integrity compromised',
            ]);
        }
        if (status_1.oxygen < 25) {
            possibleReports.push('Oxygen level is critical');
        }
        else if (status_1.oxygen < 50) {
            possibleReports.push('Oxygen level is low');
        }
        if (status_1.power < 25) {
            possibleReports.push('Power level is critical');
        }
        else if (status_1.power < 50) {
            possibleReports.push('Power level is low');
        }
        if (possibleReports.length === 0) {
            possibleReports.push.apply(possibleReports, [
                'All is well',
                'Nothing to report',
                'Internal sensors are clear',
                '',
            ]);
        }
        else {
            voyageSounds_sidecar_1.voyageSounds.playCompWarning1();
        }
        report = rando_sidecar_1.rando.sample(possibleReports);
        diveCrew_sidecar_1.diveCrew.say(obj, report);
    }
}
exports.crewUpdate = crewUpdate;
function onLeave(obj) {
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(false);
}
exports.onLeave = onLeave;
function onSelectedCrewOn(obj) {
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(true, obj.tile);
}
exports.onSelectedCrewOn = onSelectedCrewOn;
